module.exports = __webpack_public_path__ + "img/16581258_L.38ccc0a5.png";